button {
  all: unset;
}

.pages {
  display: flex;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
}